import { Injectable, inject } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { SKILLS_COLLECTION } from '@dges/modules/portfolio/domain';
import { SNACKBAR_FACADE } from '@dges/modules/snackbar';

import * as SkillsActions from './skills.actions';
import { of, from } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';

@Injectable()
export class SkillsEffects {
  private actions$ = inject(Actions);
  private angularFire = inject(SKILLS_COLLECTION);
  private snackBar = inject(SNACKBAR_FACADE);

  init$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SkillsActions.init),
      switchMap(() =>
        this.angularFire.getSkills().pipe(
          map((action) => {
            return SkillsActions.loadSkillsSuccess({ skills: action });
          }),
          catchError((error) => of(SkillsActions.loadSkillsFailure(error))),
        ),
      ),
    ),
  );

  public addSkill$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SkillsActions.addSkill),
      switchMap((actionProps) =>
        from(this.angularFire.addSkill(actionProps.skill)).pipe(
          map(() => {
            return SkillsActions.addSkillSuccess();
          }),
          catchError((error) => {
            this.snackBar.queueSnackBar(error.message);
            return of(SkillsActions.addSkillFail(error));
          }),
        ),
      ),
    ),
  );

  public deleteSkill$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SkillsActions.deleteSkill),
      switchMap((actionProps) =>
        from(this.angularFire.deleteSkill(actionProps.skill)).pipe(
          map(() => {
            return SkillsActions.deleteSkillSuccess();
          }),
          catchError((error) => {
            this.snackBar.queueSnackBar(error.message);
            return of(SkillsActions.deleteSkillFail(error));
          }),
        ),
      ),
    ),
  );

  public editSkill$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SkillsActions.editSkill),
      switchMap((actionProps) =>
        from(this.angularFire.editSkill(actionProps.skill)).pipe(
          map(() => {
            return SkillsActions.editSkillSuccess();
          }),
          catchError((error) => {
            this.snackBar.queueSnackBar(error.message);
            return of(SkillsActions.editSkillFail(error));
          }),
        ),
      ),
    ),
  );
}
